import { AccountMembership } from '@mkp/account-membership/models';
import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { QueryOptions } from '@mkp/shared/util-pagination';

export const accountMembershipActions = createActionGroup({
  source: 'Account Membership',
  events: {
    Reset: emptyProps(),
    'Load Account Memberships': props<{ query: QueryOptions }>(),
    'Load Account Memberships Success': props<{ accountMemberships: AccountMembership[] }>(),
    'Load Account Memberships Failure': props<{ error: { message: string } }>(),
    'Load More Account Memberships': props<{ query: QueryOptions }>(),
    'Load More Account Memberships Success': props<{
      accountMemberships: AccountMembership[];
      _links: any;
      filter: any;
      totalCount: any;
    }>(),
    'Load More Account Memberships Failure': props<{ error: { message: string } }>(),
    'Create Account Membership': props<{ accountId: string; userId: string }>(),
    'Create Account Membership Success': props<{ accountMembership: AccountMembership }>(),
    'Create Account Membership Failure': props<{ error: { message: string } }>(),
    'Delete Account Membership Success': props<{ accountMembershipId: string }>(),
    'Delete Account Membership Failure': emptyProps(),
    'Create User Account Membership Failure': props<{ error: { message: string } }>(),
    'Patch Roles Success': props<{ accountMembership: AccountMembership; isSelfUpdate: boolean }>(),
    'Patch Roles Failure': props<{ status: number }>(),
    'Delete Success': props<{ accountMembership: AccountMembership; isSelfDelete: boolean }>(),
    'Delete Failure': props<{
      status: number;
      accountMembershipId: string;
      isSelfDelete: boolean;
    }>(),
    'Update Receive New Application Emails Success': props<{
      accountMembershipId: string;
      receiveNewApplicationEmails: boolean;
      _version: string;
    }>(),
  },
});
